import { LOAD_VALORESSESIONFORM, RESET_VALORESSESIONFORM } from '../actions/generales/actionTypes';

const valoresSesionForm = { IdRegAudit: null, Formulario: null, Usuario: null, Permiso: null, FechaProceso: null,
    CambioFechaProceso: null, CantidadDias: null, Departamento: null};

const sesionReducer = (state={valoresSesionForm}, action) => {
    switch(action.type){
        case LOAD_VALORESSESIONFORM:                        
        case RESET_VALORESSESIONFORM:
            return {...state, valoresSesionForm: action.data };
        default:
            return state;
    }
};

export default sesionReducer;